"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecordLogKey = void 0;
exports.getRecordLogKey = function (record) {
    return "" + record.recordID; // TODO: Change to UK
};
